import React from 'react';
import {useHistory, useLocation} from 'react-router-dom';
import {PATHS} from '../Routes';
import {useComputedReservationDetails} from '../context/computedReservationDetails';

function useRedirectsGlobal() {
  const history = useHistory();
  const location = useLocation();
  const {
    hasDeposits,
    hasTaxes,
    hasUpselling,
    hasGuestMembers,
    isIdentityVerificationEnabled,
    isReservationLoaded,
    reservation,
  } = useComputedReservationDetails();
  const {pathname} = location;

  React.useEffect(
    function redirectToTaxes() {
      // const isTaxesURL = pathname.includes(PATHS.touristTaxes);
      // const isBiomatchURL = pathname.includes('verification');
      // const isBiomatchResults = pathname.includes('biomatch-results');
      // const isPaymentsURL = pathname.includes(PATHS.pay);
      //
      // const hasReservation = Boolean(reservation?.id);
      // const wasTaxesPaymentSkipped =
      //   !isPaymentsURL &&
      //   !isBiomatchURL &&
      //   !isBiomatchResults &&
      //   !isTaxesURL &&
      //   hasGuestMembers &&
      //   hasReservation &&
      //   hasTaxes;
      // if (wasTaxesPaymentSkipped) {
      //   history.push(`${PATHS.touristTaxes}/1`, {wasPaymentSkipped: true});
      // }
    },
    [hasGuestMembers, hasTaxes, history, pathname, reservation],
  );

  React.useEffect(
    function redirectToDeposits() {
      // const isTaxesURL = pathname.includes(PATHS.touristTaxes);
      // const isDepositsURL = pathname.includes('deposits');
      // const isBiomatchResultsURL = pathname.includes('biomatch-results');
      // const isBiomatchURL = pathname.includes('verification');
      // const isPaymentsURL = pathname.includes(PATHS.pay);
      //
      // const hasReservation = Boolean(reservation?.id);
      // const wasDepositsPaymentSkipped =
      //   !isPaymentsURL &&
      //   !isTaxesURL &&
      //   !isBiomatchURL &&
      //   !isDepositsURL &&
      //   !isBiomatchResultsURL &&
      //   hasReservation &&
      //   hasGuestMembers &&
      //   !hasTaxes &&
      //   paymentsDetails?.deposit.required &&
      //   hasDeposits;
      //
      // if (wasDepositsPaymentSkipped) {
      //   history.push('/deposits/payment', {wasPaymentSkipped: true});
      // }
    },
    [hasGuestMembers, hasDeposits, hasTaxes, history, pathname, reservation],
  );

  React.useLayoutEffect(
    function redirectFromVerification() {
      const isVerificationURL = pathname.includes(PATHS.verificationStart);
      const needRedirectFromVerification =
        isVerificationURL && isReservationLoaded && !isIdentityVerificationEnabled;

      if (needRedirectFromVerification) {
        history.push(PATHS.home, location.state);
      }
    },
    [
      history,
      isIdentityVerificationEnabled,
      isReservationLoaded,
      location.state,
      pathname,
    ],
  );

  React.useLayoutEffect(
    function redirectFromUpselling() {
      const isExperiencesURL = pathname.includes(PATHS.experiences);
      const needRedirectFromUpselling =
        isReservationLoaded && !hasUpselling && isExperiencesURL;

      if (needRedirectFromUpselling) {
        history.push(PATHS.home, location.state);
      }
    },
    [hasUpselling, history, isReservationLoaded, location.state, pathname],
  );
}

export {useRedirectsGlobal};
